import React from 'react';
import PropTypes from 'prop-types';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import SVG from 'react-inlinesvg';
import SloganImg from '../../assets/images/slogan.svg';
import FooterComponent from './Footer.styles';
import { useTranslation } from 'react-i18next';

import {
  SubscribeWrapper,
  FsSocialWrapper,
  SocialWrapper,
  LinksWrapper,
  Row,
  Slogan,
  FsGrid,
  Grid,
  ColumnsWrapper,
} from './Footer.styles';

import { useDeviceResize } from '../../hooks';

import SubscribeLoader from './SubscribeLoader.jsx';
import SocialLinks from '../shared/SocialLinks/SocialLinks.jsx';
import LinksList from './LinksList/LinksList.jsx';

const Footer = (props) => {
  const {
    sitecoreContext = {},
    variant = 'red',
  } = props;
  const { globalContent = {}, site, context = {} } = sitecoreContext;
  const { footer = {}, homepageLink } = globalContent;
  const {
    companyTagLineSvg = {},
    linkColumns = [],
    socialLinks = [],
    utilityLinks = [],
    widgets = [],
  } = footer;
  const device = useDeviceResize();

  const { t } = useTranslation();

  const hideSubscribeCanada = site?.name === 'bushs-beans-canada';
  if (site?.name === 'bushs-beans-foodservices') {
    const endpoint = widgets.find((widget) => widget?.type === 'industry-subscribe-form')?.actionDestination;
    return (
      <FooterComponent variant={variant} className="hide-on-print">
        <FsGrid $hideSubscribe={hideSubscribeCanada}>
          {!hideSubscribeCanada && (
            <SubscribeWrapper>
              <span className="h1">
                sign up for industry updates
              </span>
              <SubscribeLoader
                endpoint={endpoint}
                placeholder={t(
                  'BushsBeans.Global.Footer.SubscribePlaceholder',
                  'enter your email'
                )}
                success={t(
                  'BushsBeans.Global.Footer.SubscribeSuccessMessage',
                  'thanks for subscribing'
                )}
                error={t(
                  'BushsBeans.Global.Footer.SubscribeErrorMessage',
                  'please enter valid email'
                )}
              />
            </SubscribeWrapper>
          )}

          <ColumnsWrapper className="fs-foter-columns" variant="blue">
            {linkColumns &&
              linkColumns?.map((links, index) => <LinksList key={`LinksList-${index}`} {...links} />)}
          </ColumnsWrapper>

          {socialLinks && (
            <FsSocialWrapper variant={variant}>
              <h3 className="list-title emphasis small">
                {t('BushsBeans.Global.Footer.SocialTitle', 'Connect')}
              </h3>
              {socialLinks && <SocialLinks links={socialLinks} />}
            </FsSocialWrapper>
          )}
        </FsGrid>

        <Row>
          <Slogan>
            <SVG src={SloganImg} />
          </Slogan>
        </Row>
        <Row variant={variant}>
          {utilityLinks && (
            <>
              <nav>
                <ul>
                  {utilityLinks &&
                    utilityLinks.map(({ href, path, target, title }, index) => (
                      <li key={`utilityLink-${index}_${href || path}`}>
                        <a href={href || path} target={target || '_self'}>
                          {title}
                        </a>
                      </li>
                    ))}
                </ul>
              </nav>
              <small>
                {t(
                  'BushsBeans.Global.Footer.copywrite',
                  '© BUSH BROTHERS & COMPANY. ALL RIGHTS RESERVED.'
                )}
              </small>
            </>
          )}
        </Row>
      </FooterComponent>
    );
  } else {
    const endpoint = widgets.find((widget) => widget?.type === 'subscribe-form')?.actionDestination;
    return (
      <FooterComponent variant={variant} className={`hide-on-print ${site?.name}`}>
        <Grid $hideSubscribe={hideSubscribeCanada}>
          {!hideSubscribeCanada && (
          <SubscribeWrapper>
            <span className="h1">{t('BushsBeans.Global.Footer.SubscribeTitle', 'subscribe for bean news')}</span>
            <SubscribeLoader
              endpoint={endpoint}
              placeholder={t('BushsBeans.Global.Footer.SubscribePlaceholder', 'enter your email')}
              success={t('BushsBeans.Global.Footer.SubscribeSuccessMessage', 'Thanks for signing up!')}
              error={t('BushsBeans.Global.Footer.SubscribeErrorMessage', 'please enter valid email')}
            />
          </SubscribeWrapper>
          )}
          {socialLinks && (
            <SocialWrapper variant={variant}>
              <h3 className="list-title emphasis small">{t('BushsBeans.Global.Footer.SocialTitle', 'Connect')}</h3>
              {socialLinks && <SocialLinks links={socialLinks} />}
            </SocialWrapper>
          )}
          <LinksWrapper className={(device === 'desktop') ? 'link-wrapper' : 'hiding'}
                        variant={variant}>{linkColumns && linkColumns?.map((links, index) => <LinksList
            key={`LinksList-${index}`} {...links} />)}</LinksWrapper>
        </Grid>

        <Row>
          <Slogan>
            <SVG src={companyTagLineSvg?.src} />
          </Slogan>
        </Row>
        <Row variant={variant}>
          {utilityLinks && (
            <>
              <nav>
                <ul>
                  {utilityLinks &&
                    utilityLinks.map(({ href, path, target, title }, index) => (
                      <li key={`utilityLink-${index}_${href || path}`}>
                        <a href={href || path} target={target}>{title}</a>
                      </li>
                    ))}
                </ul>
              </nav>
              <small>{t(
                'BushsBeans.Global.Footer.copywrite',
                '© BUSH BROTHERS & COMPANY. ALL RIGHTS RESERVED.'
              )}</small>
            </>
          )}
        </Row>
      </FooterComponent>
    );
  }
};

Footer.propTypes = {
  sitecoreContext: PropTypes.shape({
    globalContent: PropTypes.shape({
      footer: PropTypes.shape({
        companyTagLineSvg: PropTypes.object,
        utilityLinks: PropTypes.shape({
          title: PropTypes.string,
          links: PropTypes.array,
        }),
        linkColumns: PropTypes.shape({
          columnTitle: PropTypes.string,
          links: PropTypes.array,
        }),
        socialLinks: PropTypes.shape({
          title: PropTypes.string,
          links: PropTypes.array,
        }),
        widgets: PropTypes.array,
      }),
    }),
  }),
};

export default withSitecoreContext()(Footer);